export const STREAM_STATUSES = {
  0: { label: 'pending' },
  1: { label: 'in_progress' },
  2: { label: 'done' },
  3: { label: 'restart' },
  4: { label: 'failure' },
  5: { label: 'stop' },
  6: { label: 'unknown' },
  7: { label: 'handler_lost' },
  8: { label: 'paused' },
};
